import { FC, useCallback } from 'react';
import { Input, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import createUid from '~/utils/createUid';
import Section from '~/layouts/Section ';
import Form from '~/components/WizardForm';
import { DocumentInput } from '~/components';
import { NamePath } from '~/utils/buildNamePath';
import InputsGroupLayout from '~/layouts/InputsGroupLayout';
import ManualScreeningResolutionSelect from './ManualScreeningResolutionSelect';

interface Props {
  baseNamePath: NamePath;
}

const ManualScreeningResultsForm: FC<Props> = ({ baseNamePath }: Props) => {
  const [t] = useTranslation('ksaReview');

  const n = useCallback(
    (namePath: NamePath) => [baseNamePath].flat().concat([namePath].flat()),
    [baseNamePath]
  );

  return (
    <>
      <Typography.Title level={5}>{t('Manual screening results').toUpperCase()}</Typography.Title>
      <Section formItemLast>
        <Typography.Paragraph>
          {t(
            'In case of complex ownership structure please provide comments and/or schemas that might be relevant.'
          )}
        </Typography.Paragraph>
        <Form.Item name={n('uid')} hidden initialValue={createUid()} />
        <Form.Item name={n('files')}>
          <DocumentInput name="photos" variant="default" />
        </Form.Item>
        <InputsGroupLayout>
          <Form.Item label={t('Screening resolution')} name={n('resolution')}>
            <ManualScreeningResolutionSelect />
          </Form.Item>
        </InputsGroupLayout>
        <Section formItemLast>
          <Form.Item name={n('comment')}>
            <Input.TextArea autoSize={textareaAutoSize} placeholder={t('Enter your comment')} />
          </Form.Item>
        </Section>
      </Section>
    </>
  );
};

const textareaAutoSize = { minRows: 2 };

export default ManualScreeningResultsForm;
